import { reactive } from 'vue'
import { loginCommonConfig } from './common'
import type { LoginPageConfig } from './types'

export const theme = {
  facebookBlue: '#1A77F2',
  googleBlue: '#239FFB',
  appleDark: '#282828',
  inputBorder: '#DCC8FF',
} as const

export const resources = {
  loginBg: '/images/pearla/login/login-bg.webp',
  logo: '',
  novel: '',
  facebookIcon: '/images/pearla/login/icon-facebook-logo.png',
  googleIcon: '/images/pearla/login/icon-google-logo.png',
  appleIcon: '/images/pearla/login/icon-apple-logo.png',
  emailIcon: '/images/pearla/login/icon-email.png',
  emailCodeIcon: '/images/pearla/login/icon-email-code.png',
} as const

export const loginConfig: LoginPageConfig = {
  theme,
  resources,
  texts: reactive(loginCommonConfig.texts),
}
